/**
 * Header + overlay re-hydration
 *
 * Why: Cloudflare caches full HTML of product/collection pages. The header
 * (cart count, account button label/href, customer-tag-aware announcement
 * blocks) AND overlay-group (cart-drawer body, line-item-property, product
 * compare, quick-view) are rendered server-side and get frozen in the cached
 * HTML, so a visitor who logs in or updates the cart and returns to a
 * previously cached page sees stale content.
 *
 * Fix: on every page load, fetch the current values for the header-group and
 * overlay-group sections via the Shopify Section Rendering API and swap them
 * in. The cache-buster prevents both the browser and the CDN from serving a
 * stale response for the rehydration request itself. A Cloudflare cache rule
 * must also bypass cache when the URL contains `sections=`.
 */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  var GROUP_SELECTOR = '#HeaderGroup > .shopify-section, #OverlayGroup > .shopify-section';

  function collectSectionIds() {
    var nodes = document.querySelectorAll(GROUP_SELECTOR);
    var ids = [];
    for (var i = 0; i < nodes.length; i++) {
      var id = nodes[i].id.replace(/^shopify-section-/, '');
      if (id) ids.push(id);
    }
    return ids;
  }

  function reExecuteInlineScripts(container) {
    // External scripts (header.js, menu-drawer-mobile.js, search.js) define
    // global custom elements — they are already loaded once at boot. Re-running
    // them throws "already declared" / "already used" errors. Custom elements
    // in the swapped DOM are upgraded automatically by the browser.
    var scripts = container.querySelectorAll('script:not([src])');
    for (var i = 0; i < scripts.length; i++) {
      var oldScript = scripts[i];
      var newScript = document.createElement('script');
      for (var j = 0; j < oldScript.attributes.length; j++) {
        var attr = oldScript.attributes[j];
        newScript.setAttribute(attr.name, attr.value);
      }
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    }
  }

  function rehydrate() {
    var ids = collectSectionIds();
    if (!ids.length) return;

    var url = window.location.pathname
      + '?sections=' + encodeURIComponent(ids.join(','))
      + '&_=' + Date.now();

    fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (json) {
        if (!json) return;

        for (var i = 0; i < ids.length; i++) {
          var id = ids[i];
          var html = json[id];
          if (typeof html !== 'string') continue;

          var wrapper = document.getElementById('shopify-section-' + id);
          if (!wrapper) continue;
          if (wrapper.innerHTML.trim() === html.trim()) continue;

          wrapper.innerHTML = html;
          reExecuteInlineScripts(wrapper);

          document.dispatchEvent(new CustomEvent('shopify:section:load', {
            detail: { sectionId: id, load: true }
          }));
        }

        document.documentElement.setAttribute('data-header-hydrated', 'true');
      })
      .catch(function () { /* swallow — stale header is better than crash */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rehydrate, { once: true });
  } else {
    rehydrate();
  }
})();
